import { useState } from 'react'
import { Navigate } from 'react-router-dom'

import { Signup as SignIn } from '../components/common'
import PreLoginLayout from '../components/common/PreLoginLayout'
import initFirebase from '../db/initFirebase'
import Database from '../types/Database'

import routes from './routes'

const Signin = () => {
  const [LoggedInUser, setLoggedInUser] = useState<Database.User | undefined>(
    undefined
  )

  initFirebase
    .getFireBaseStore()
    .auth.onAuthStateChanged(function (user: Database.User | undefined | null) {
      if (user) {
        setLoggedInUser(user)
      }
    })

  return (
    <PreLoginLayout>
      {!LoggedInUser && <SignIn />}
      {LoggedInUser && <Navigate to={routes.home} />}
    </PreLoginLayout>
  )
}

export default Signin
